var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"geoCentent"},[_c('div',{staticClass:"geoBox",attrs:{"id":"geoBox"}}),_c('div',{staticClass:"tipBox"},[_c('div',{staticClass:"tab"}),_c('div',{staticClass:"tabText"},[_c('span',[_vm._v("0分")]),_c('span',[_vm._v("10分")])])])])
}]

export { render, staticRenderFns }